import React from 'react';
import { connect } from 'react-redux';

import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';

import { Notification } from '@apps/shared/src/notification/types/notification';
import { RootState } from '../store';

type StateProps = {
  notifications: Notification[];
  enableNotification: boolean;
  hasClientViewRole: boolean;
};

type ParentProps = {
  onClick: () => void;
};

const mapStateToProps = ({ notification, user }: RootState): StateProps => ({
  notifications: notification.notifications || [],
  enableNotification: user?.currentUser?.enableNotification || false,
  hasClientViewRole: user.currentUser?.roles?.includes('medivi-caseviewclient') ?? false,
});

type Props = StateProps & ParentProps;

const NotificationBell = ({
  onClick,
  notifications,
  enableNotification,
  hasClientViewRole,
}: Props) => {
  const unreadCount = hasClientViewRole
    ? notifications.filter(n => !n.isRead).length
    : notifications.filter(n => !n.isRead && n.recordType !== 'Appeal').length;

  return (
    <IconButton style={{ marginTop: '.2rem' }} onClick={onClick} size="large">
      <Badge badgeContent={enableNotification ? unreadCount : null} color="primary">
        <NotificationsIcon style={{ color: 'white' }} />
      </Badge>
    </IconButton>
  );
};

export default connect(mapStateToProps, null)(NotificationBell);
